import { cmsReducer } from "./cms/reducer";
import { combineReducers } from 'redux';
export var cmsRootReducer = combineReducers({
    api: cmsReducer,
});
export default cmsRootReducer;
